import axios from 'axios'
import { config } from './config'
import {store} from "@/store";

const apiUrl = config.$api_url

export default {
    get(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-accounts', data)
            .then(response => response.data)
    },
    getMefete(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mefete-accounts', data)
            .then(response => response.data)
    },
    getPep(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/pep-accounts', data)
            .then(response => response.data)
    },
    detailMefete(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mefete-account-detail', data)
            .then(response => response.data)
    },
    detailPep(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/pep-account-detail', data)
            .then(response => response.data)
    },
    detail(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-detail', data)
            .then(response => response.data)
    },
    addMefete(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mefete-account-add', data)
            .then(response => response.data)
    },
    addPep(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/pep-account-add', data)
            .then(response => response.data)
    },
    add(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-add', data)
            .then(response => response.data)
    },
    editMefete(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-mefete-update', data)
            .then(response => response.data)
    },
    edit(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-update', data)
            .then(response => response.data)
    },
    editPep(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-pep-update', data)
            .then(response => response.data)
    },
    removeMefete(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mefete-account-remove', data)
            .then(response => response.data)
    },
    remove(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-remove', data)
            .then(response => response.data)
    },
    removePep(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/pep-account-remove', data)
            .then(response => response.data)
    },
    changeStatusMefete(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mefete-account-change-status', data)
            .then(response => response.data)
    },
    changeStatusPep(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/pep-account-change-status', data)
            .then(response => response.data)
    },
    changeStatus(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-change-status', data)
            .then(response => response.data)
    },
    changeFast(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-change-fast', data)
            .then(response => response.data)
    },
    changeNextDay(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-change-next-day', data)
            .then(response => response.data)
    },
    mailes(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mails', data)
            .then(response => response.data)
    },
    mailDetail(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mail-detail', data)
            .then(response => response.data)
    },
    mailDetailId(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mail-detail-id', data)
            .then(response => response.data)
    },
    mailsAmount(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/mails-amount', data)
            .then(response => response.data)
    },
    answers(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/answers', data)
            .then(response => response.data)
    },
    addAnswer(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/add-answer', data)
            .then(response => response.data)
    },
    editAnswer(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-answer', data)
            .then(response => response.data)
    },
    removeAnswer(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-answer', data)
            .then(response => response.data)
    },
    detailAnswer(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/detail-answer', data)
            .then(response => response.data)
    },
    groups(){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/bank-account-groups')
            .then(response => response.data)
    },
    addGroup(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/add-bank-account-group', data)
            .then(response => response.data)
    },
    editGroup(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-bank-account-group', data)
            .then(response => response.data)
    },
    detailGroup(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/detail-bank-account-group', data)
            .then(response => response.data)
    },
    removeGroup(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-bank-account-group', data)
            .then(response => response.data)
    },
    answersWithdrawal(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/answers-witdhrawal', data)
            .then(response => response.data)
    },
    addAnswerWithdrawal(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/add-answer-witdhrawal', data)
            .then(response => response.data)
    },
    editAnswerWithdrawal(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-answer-witdhrawal', data)
            .then(response => response.data)
    },
    removeAnswerWithdrawal(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-answer-witdhrawal', data)
            .then(response => response.data)
    },
    detailAnswerWithdrawal(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/detail-answer-witdhrawal', data)
            .then(response => response.data)
    },


}